import PropTypes from 'prop-types';

import { getAsset, getContent } from '@/utils/helper';

import { Media } from './Media';

// For single image
function CtfMedia({
  assets,
  callToAction,
  entries,
  field,
  style,
  lightbox,
  container,
}) {
  const asset = field ? getAsset(field?.sys?.id, assets) : null;
  const { contentType, url, title } = asset?.fields?.file || {};
  const cta = callToAction ? getContent(callToAction.sys.id, entries) : null;

  if (!asset) {
    return null;
  }

  return (
    <Media
      ctaUrl={url}
      contentType={contentType}
      isCta={Boolean(cta)}
      mediaUrl={url}
      style={style}
      title={title}
      lightbox={lightbox}
      container={container}
    />
  );
}

CtfMedia.propTypes = {
  assets: PropTypes.array,
  callToAction: PropTypes.object,
  entries: PropTypes.array,
  field: PropTypes.any,
  lightbox: PropTypes.bool,
  // classname
  style: PropTypes.string,
};

CtfMedia.defaultProps = {
  assets: [],
  entries: [],
  lightbox: false,
  style: '',
};

export default CtfMedia;
